import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import ToastMessage from 'src/Admin/components/common/ToastMessage';
import { axiosInstance } from 'src/api/axios';
import * as yup from 'yup';

const useMyPublishMessage = (userTypeSelectedValue = 'Member') => {
  //Common
  const userTypeData = useSelector((state) => state?.user?.userData?.UserType);
  const userOid = useSelector((state) => state?.user?.userData?.Oid);
  const isBlobEmpLocFlow = useSelector(
    (state) =>
      state?.app?.appConfigs?.Network_Setting?.Broker_User_Creation_Setting,
  );
  const userType = userTypeSelectedValue;
  const navigate = useNavigate();

  //Message type dropdown configs
  const getEventTypeList = async () => {
    try {
      const responseEventTypeCategory = await axiosInstance.get(
        APIEndpoints.getEventTypeOid(),
      );
      const eventTypeListData =
        responseEventTypeCategory?.data?.Response?.MessageEventMaster;

      const typeCategoryValues = eventTypeListData.map((item) => {
        return {
          label: item?.MessageEventDesc,
          value: item?.oid,
        };
      });

      const filteredMessageType = typeCategoryValues.filter(
        (item) => item?.label !== 'Document',
      );
      setMESSAGE_TYPE_OPTIONS(filteredMessageType);
    } catch (err) {
      console.log('err :', err);
    }
  };

  const [publishedCategoryOid, setPublishedCategoryOid] = useState([]);

  const getTypeList = async () => {
    try {
      const responseTypeCategory = await axiosInstance.get(
        APIEndpoints.getTypeCategoryList(),
      );
      const typeListData =
        responseTypeCategory?.data?.Response?.MessageCategoryMaster;

      setPublishedCategoryOid(
        typeListData.filter((item) => item?.Categorycode === 'Published')[0]
          ?.Oid,
      );
    } catch (err) {
      console.log('err :', err);
    }
  };

  useEffect(() => {
    getEventTypeList();
    getTypeList();
  }, []);

  const [MESSAGE_TYPE_OPTIONS, setMESSAGE_TYPE_OPTIONS] = useState([]);
  const [messageType, setMessageType] = useState();

  //Messasge Send To Configs
  const formFields = {
    Oid: '',
    userType: { value: userTypeData },
    brokers: [],
    allBrokers: [],
    BLOBDetails: {
      blobSelected: [],
      allBLOBData: [],
      selectedEmployers: {},
      allEmployersData: [],
      selectedLocations: {},
      allLocationsData: [],
    },
    providerDetails: {
      facilities: [],
      selectedDoctorsByFacility: {},
    },
    personalInformation: {},
    permissions: [],
    allPermissions: [],
    doctors: [],
  };
  const [blobCheck, setBlobCheck] = useState(true);
  const [permissionCheck, setPermissionCheck] = useState(false);
  const [plansCheck, setPlansCheck] = useState(false);
  const [brokersCheck, setBrokersCheck] = useState(false);
  const [providersCheck, setProvidersCheck] = useState(true);

  //Bolb Data Configs
  const defaultSendToBlobData = {
    blobSelected: [],
    allBLOBData: [],
    selectedEmployers: {},
    allEmployersData: [],
    selectedLocations: {},
    allLocationsData: [],
  };
  const [sendToBlobData, setSendToBlobData] = useState(defaultSendToBlobData);
  const [selectedBlobData, setSelectedBlobData] = useState([]);
  const [selectedEmployerData, setSelectedEmployerData] = useState({});
  const [selectedLocationData, setSelectedLocationData] = useState({});
  const [selectedBrokerData, setSelectedBrokerData] = useState();

  const [hasDoctors, setHasDoctors] = useState(false);
  const [hasFacilities, setHasFacilities] = useState(false);
  const [selectedDoctorsData, setSelectedDoctorsData] = useState([]);
  const [selectedFacilityData, setSelectedFacilityData] = useState([]);

  const setSendToBlobDataHandler = (data) => {
    console.log('BLOBDATA', data);
    setSelectedBlobData(data?.blobSelected);
    setSelectedEmployerData(data?.selectedEmployers);
    setSelectedLocationData(data?.selectedLocations);
  };

  //Permisssion Data Configs
  const [sendToPermissionData, setSendToPermissionData] = useState([]);
  const setSendToPermissionDataHandler = (data) => {
    setSendToPermissionData(data);
  };

  //Send To field's Checkbox Configs
  const renderSendToCheckboxes = ({ field, setFieldTouched, form }) => {
    let addBlockofBussinessOption = false;
    let addBlockofBussinessWithoutBlockOption = false;
    let addPermissionOption = false;
    let addBrokerOption = false;
    let addProviderOption = false;

    switch (userTypeSelectedValue) {
      case 'Insurer':
        setProvidersCheck(false);
        addBlockofBussinessOption = true;
        addBlockofBussinessWithoutBlockOption = false;
        addPermissionOption = true;
        addBrokerOption = false;
        addProviderOption = false;
        break;
      case 'Member':
        addBlockofBussinessOption = true;
        setProvidersCheck(false);
        addBlockofBussinessWithoutBlockOption = false;
        addPermissionOption = true;
        addBrokerOption = false;
        addProviderOption = false;
        break;
      case 'Broker':
        setProvidersCheck(false);
        addBlockofBussinessOption = true;
        addBlockofBussinessWithoutBlockOption = !isBlobEmpLocFlow;
        addPermissionOption = true;
        addBrokerOption = true;
        addProviderOption = false;
        break;
      case 'Provider':
        addBlockofBussinessOption = false;
        setBlobCheck(false);
        addBlockofBussinessWithoutBlockOption = false;
        addPermissionOption = true;
        addBrokerOption = false;
        addProviderOption = true;
        break;
      case 'Client':
        setProvidersCheck(false);
        addBlockofBussinessOption = true;
        addBlockofBussinessWithoutBlockOption = true;
        addPermissionOption = true;
        addBrokerOption = false;
        addProviderOption = false;
        break;
      default:
        setProvidersCheck(false);
        addBlockofBussinessOption = true;
        addBlockofBussinessWithoutBlockOption = false;
        addPermissionOption = true;
        addBrokerOption = false;
        addProviderOption = false;
        break;
    }
    return (
      <>
        {addBlockofBussinessOption && (
          <label className="d-flex">
            <input
              type="checkbox"
              {...field}
              checked={field.value.includes('blockOfBusiness')}
              className="ml-0"
              onChange={() => {
                setFieldTouched('messageSentTo');
                setSendToBlobData(defaultSendToBlobData);
                const value = [...field.value];
                if (field.value.includes('blockOfBusiness')) {
                  setBlobCheck(false);
                  const index = field.value.indexOf('blockOfBusiness');
                  value.splice(index, 1);
                } else {
                  setBlobCheck(true);
                  value.push('blockOfBusiness');
                }
                form.setFieldValue(field.name, value);
              }}
            />
            <div className="sendto-labels">
              {`${
                addBlockofBussinessWithoutBlockOption
                  ? ''
                  : 'Block of Business+'
              }Employer+Location`}
            </div>
          </label>
        )}
        {addProviderOption && (
          <label className="d-flex">
            <input
              type="checkbox"
              {...field}
              checked={field.value.includes('Providers')}
              onChange={() => {
                setFieldTouched('messageSentTo');
                const value = [...field.value];
                if (field.value.includes('Providers')) {
                  const index = field.value.indexOf('Providers');
                  value.splice(index, 1);
                  setProvidersCheck(false);
                } else {
                  value.push('Providers');
                  setProvidersCheck(true);
                }
                form.setFieldValue(field.name, value);
              }}
            />
            <div className="sendto-labels">Providers</div>
          </label>
        )}
        {addPermissionOption && (
          <label className="d-flex">
            <input
              type="checkbox"
              {...field}
              checked={field.value.includes('permission')}
              onChange={() => {
                setFieldTouched('messageSentTo');
                const value = [...field.value];
                if (field.value.includes('permission')) {
                  const index = field.value.indexOf('permission');
                  value.splice(index, 1);
                  setPermissionCheck(false);
                } else {
                  value.push('permission');
                  setPermissionCheck(true);
                }
                form.setFieldValue(field.name, value);
              }}
            />
            <div className="sendto-labels">Permissions</div>
          </label>
        )}
        {addBrokerOption && (
          <label className="d-flex">
            <input
              type="checkbox"
              {...field}
              checked={field.value.includes('brokers')}
              onChange={() => {
                setFieldTouched('messageSentTo');
                const value = [...field.value];
                if (field.value.includes('brokers')) {
                  const index = field.value.indexOf('brokers');
                  value.splice(index, 1);
                  setBrokersCheck(false);
                } else {
                  value.push('brokers');
                  setBrokersCheck(true);
                }
                form.setFieldValue(field.name, value);
              }}
            />
            <div className="sendto-labels">Brokers</div>
          </label>
        )}
      </>
    );
  };

  //Message configs
  const [messageTitle, setMessageTitle] = useState();
  const [messageContent, setMessageContent] = useState();
  const getMessageHtml = (htmlValue) => {
    setMessageContent(JSON.stringify(htmlValue));
    console.log('val messageContent :', messageContent, htmlValue);
  };
  const [sendEmail, setSendEmail] = useState(false);

  //Duration Configs
  const [durationFrom, setDurationFrom] = useState();
  const [durationTo, setDurationTo] = useState();
  const { Default_Time_Format } = useSelector(
    ({ app }) => app?.appConfigs?.Time_Setting || 'mm/dd/yyyy',
  );

  //Attachments Configs
  const [files, setFiles] = useState([]);
  const [fileUploadStatus, setFileUploadStatus] = useState('pending');
  const [fileProgress, setFileProgress] = useState(0);
  const [filesLoader, setfilesLoader] = useState(false);
  const [multiSelectFlag, setMultiSelectFlag] = useState(false);
  const isComingFromPortalTiPortal = true;

  const attachDocuments = async (item, index) => {
    let percent = 0;
    const config = {
      headers: {
        'Content-Type': item?.file?.type,
        Accept: 'application/json',
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        percent = Math.floor((loaded * 100) / total);
        if (percent <= 100) {
          setFileProgress(percent);
          setFiles((current) =>
            current.map((obj, i) => {
              if (i === index) {
                return {
                  ...obj,
                  uploadPercent: percent,
                };
              }
              return obj;
            }),
          );
        }
      },
    };

    return await axiosInstance
      .post(
        APIEndpoints.postDocumentResource() +
          `fileuri/${item?.file?.name?.split('.')[0]}/description/${
            item?.file?.name
          }`,
        item?.file,
        config,
      )
      .then((res) => {
        setFiles((current) =>
          current.map((obj, i) => {
            if (i === index) {
              return {
                ...obj,
                uploadStatus: 'uploaded',
                fileOid: res?.data?.Response?.Oid,
                uploadPercent: 100,
              };
            }
            return obj;
          }),
        );
        setFileUploadStatus('uploaded');
        return res;
      })
      .catch((err) => {
        setFiles((current) =>
          current.map((obj, i) => {
            if (i === index) {
              return { ...obj, uploadStatus: 'failed', uploadPercent: 100 };
            }
            return obj;
          }),
        );
        setFileUploadStatus('failed');
        return Promise.reject(err);
      });
  };

  const initiateFileUpload = () => {
    setfilesLoader(true);
    const uploadPromises = files.map(async (fileItem, index) => {
      if (fileItem.uploadStatus === 'pending') {
        const documentResponse = await attachDocuments(fileItem, index);
        return documentResponse;
      }
      return;
    });

    Promise.all(uploadPromises)
      .then(() => {
        setFileUploadStatus('uploaded');
      })
      .catch(() => {
        setFileUploadStatus('failed');
      });
  };

  useEffect(() => {
    initiateFileUpload();
  }, [multiSelectFlag]);

  const handleDeleteAttachment = async (file) => {
    console.log('handleDeleteAttachment', file);

    try {
      const getDocumentOID = file?.fileOid;
      const URL = APIEndpoints.deleteDocumentAttachment() + getDocumentOID;
      const response = await axiosInstance.delete(URL, {
        headers: {
          Accept: 'application/json',
        },
      });
      console.log('response', response);
      setFiles(files.filter((item) => item.fileOid !== file?.fileOid));
      toast.success(
        <ToastMessage
          type="success"
          subTitle="The Document has been deleted successfully."
        />,
      );
    } catch (error) {
      console.log(error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Something went wrong with the request! Failed to delete document."
        />,
      );
      return 'fail';
    }
  };

  const schema = yup.object({
    messageType: yup.object().required('Please select a Message Type'),
    messageSentTo: yup
      .array()
      .min(1, 'At least one selection is required')
      .required('At least one selection is required'),
    messsagTitle: yup.string().required('Please Enter Title'),
    durationFrom: yup.date().nullable(),
    durationTo: yup.date().nullable(),
  });

  const publishSendBulkMessage = async (values, resetForm) => {
    const FormattedMessageAffiliation = [];
    if (selectedBlobData?.length > 0) {
      selectedBlobData.map((item) => {
        if (Object.keys(selectedEmployerData)?.includes(item?.oid)) {
          const employerData = Object.entries(selectedEmployerData);
          employerData.map((clientOid) => {
            if (clientOid[0] === item?.oid && clientOid[1].length > 0) {
              clientOid[1].map((employerItem) => {
                if (
                  Object.keys(selectedLocationData)?.includes(employerItem?.oid)
                ) {
                  const locationData = Object.entries(selectedLocationData);
                  locationData.map((locationOid) => {
                    if (
                      locationOid[0] === employerItem?.oid &&
                      locationOid[1].length > 0
                    ) {
                      locationOid[1].map((locationItem) => {
                        return FormattedMessageAffiliation.push({
                          BlobOid: locationItem?.BlkOfBusOid,
                          ClientOid: locationItem?.ClientOid,
                          ClientlocationOid: locationItem?.oid,
                        });
                      });
                    }
                    return 0;
                  });
                } else {
                  FormattedMessageAffiliation.push({
                    BlobOid: employerItem?.BlkOfBusOid,
                    ClientOid: employerItem?.oid,
                  });
                }
                return 0;
              });
            }
            return 0;
          });
        } else {
          FormattedMessageAffiliation.push({
            BlobOid: item?.oid,
          });
        }
        return 0;
      });
    } else if (
      selectedBlobData?.length === 0 &&
      selectedEmployerData?.length > 0
    ) {
      selectedEmployerData.map((employerItem) => {
        if (Object.keys(selectedLocationData)?.includes(employerItem?.oid)) {
          const locationData = Object.entries(selectedLocationData);
          locationData.map((locationOid) => {
            if (
              locationOid[0] === employerItem?.oid &&
              locationOid[1].length > 0
            ) {
              locationOid[1].map((locationItem) => {
                return FormattedMessageAffiliation.push({
                  BlobOid: locationItem?.BlkOfBusOid,
                  ClientOid: locationItem?.ClientOid,
                  ClientlocationOid: locationItem?.oid,
                });
              });
            }
            return 0;
          });
        } else {
          FormattedMessageAffiliation.push({
            BlobOid: employerItem?.BlkOfBusOid,
            ClientOid: employerItem?.oid,
          });
        }

        return 0;
      });
    }

    const FormattedPermissionGroups = [];
    sendToPermissionData.map((item) => {
      return FormattedPermissionGroups.push(item?.RoleName);
    });

    const FormattedProvidersMessage = [];
    if (selectedDoctorsData.length > 0) {
      selectedDoctorsData.map((item) => {
        return FormattedProvidersMessage.push({
          PhysicianOid: item?.PhysicainOid,
          FacilityOid: item?.FacilityOid,
        });
      });
    } else {
      selectedFacilityData.map((item) => {
        return FormattedProvidersMessage.push({
          FacilityOid: item?.FacilityOID,
        });
      });
    }

    const documentOidData = [];
    files.map((item) => {
      return documentOidData.push(item?.fileOid);
    });
    let fromDate = durationFrom;
    let endDate = durationTo;
    const today = new Date();
    if (!durationFrom) {
      fromDate =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1 > 9
          ? today.getMonth() + 1
          : '0' + (today.getMonth() + 1)) +
        '-' +
        (today.getDate() > 9 ? today.getDate() : '0' + today.getDate());
    }
    if (!durationTo) {
      const future = new Date(
        today.getFullYear() + 200,
        today.getMonth(),
        today.getDate(),
      );
      const date =
        future.getFullYear() +
        '-' +
        (today.getMonth() + 1 > 9
          ? today.getMonth() + 1
          : '0' + (today.getMonth() + 1)) +
        '-' +
        (future.getDate() > 9 ? future.getDate() : '0' + future.getDate());
      endDate = date;
    }

    console.log('DATE_PICKER', fromDate, endDate);
    try {
      const payLoad = {
        UserType: userType,
        UserOid: userOid,
        EventTypeOid: values?.messageType?.value,
        MessageCategoryoid: publishedCategoryOid,
        EventTitle: values?.messsagTitle,
        EventDesc: messageContent,
        StartDate: fromDate,
        EndDate: endDate,
        TerminatedDate: endDate,
        IsDeleted: false,
        DocumentDetails: documentOidData,
        PermissionGroups: FormattedPermissionGroups,
        BrokerCode: selectedBrokerData?.map((item) => item?.Code) || [],
        PPMessageAffiliation: [
          ...FormattedMessageAffiliation,
          ...FormattedProvidersMessage,
        ],
        SendEmail: sendEmail,
      };

      const publish = await axiosInstance.post(
        APIEndpoints.postSendBulkMessage(),
        payLoad,
      );
      if (publish?.status === 201) {
        navigate('/admin/Messages-Documents', {
          state: {
            comingFrom: 'publish-new-message',
            publishedSuccessfully: true,
          },
        });
      }
      console.log('blobDataSubmit_PUBLISH', payLoad);
      resetForm();
      setMessageType(null);
      setFiles([]);
      setBlobCheck(!blobCheck);
      setPermissionCheck(false);
      //setMessageContent(null);
      setTimeout(() => {
        setBlobCheck(true);
      }, 1500);
    } catch (err) {
      console.log('err', err);
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Something went wrong with the request! Failed to Publish Message."
        />,
      );
    }
  };

  //Controllers
  const publishMessageHandler = (values, errors, resetForm) => {
    if (
      values?.messageType &&
      values?.messsagTitle &&
      Object.values(errors).length === 0
    ) {
      console.log('blobDataSubmit', {
        messageType,
        mySendToBlobData: {
          selectedBlobData,
          selectedEmployerData,
          selectedLocationData,
        },
        sendToPermissionData,
        formFields,
        messageTitle,
        messageContent,
        durationFrom,
        durationTo,
        files,
      });
      publishSendBulkMessage(values, resetForm);
    }
  };

  return {
    MESSAGE_TYPE_OPTIONS,
    messageType,
    setMessageType,
    messageTitle,
    setMessageTitle,
    getMessageHtml,
    Default_Time_Format,
    durationFrom,
    setDurationFrom,
    durationTo,
    setDurationTo,
    files,
    setFiles,
    blobCheck,
    setBlobCheck,
    permissionCheck,
    setPermissionCheck,
    brokersCheck,
    setBrokersCheck,
    plansCheck,
    setPlansCheck,
    publishMessageHandler,
    formFields,
    sendToBlobData,
    setSendToBlobData,
    defaultSendToBlobData,
    sendToPermissionData,
    setSendToPermissionData,
    setSendToPermissionDataHandler,
    setSendToBlobDataHandler,
    selectedBrokerData,
    setSelectedBrokerData,
    isBlobEmpLocFlow,
    renderSendToCheckboxes,
    sendEmail,
    setSendEmail,

    selectedBlobData,
    selectedEmployerData,
    selectedLocationData,

    fileUploadStatus,
    fileProgress,
    filesLoader,
    isComingFromPortalTiPortal,
    setMultiSelectFlag,
    schema,
    handleDeleteAttachment,

    selectedDoctorsData,
    setSelectedDoctorsData,
    hasDoctors,
    setHasDoctors,
    hasFacilities,
    setHasFacilities,
    selectedFacilityData,
    setSelectedFacilityData,
    providersCheck,
  };
};

export default useMyPublishMessage;
